import { useEffect, useMemo, useRef, useState } from "react";
import "./index.scss";
import { getValue } from "@utils/lodash";
import { getLookupAPIs } from "./lookup-apis";
import CloseSmallSvgComponent from "@assets/svg-components/close-small";
import {
  convertDateAsString,
  convertDateWithSlash,
} from "@common/date-helpers";

const SingleSelectSearchDropdownReport = (props: any) => {
  const { label, id, value, width, onChange, selectKey, data } = props;

  const inputRef: any = useRef(null);
  const ref: any = useRef(null);

  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */
  const [isLoading, setIsLoading] = useState(true);
  const [query, setQuery] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [inputChange, setInputChange] = useState(false);
  const [info, setinfo] = useState<any[]>([]);
  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */
  useEffect(() => {
    if (getValue(props, `lookup_api`, "")) {
      fetchDefaultData();
    }
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);
  useEffect(() => {
    if (isOpen && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isOpen]);

  useEffect(() => {
    setQuery("");
  }, [props.resetInput]);

  useEffect(() => {
    if (query) {
      setInputChange(true);
    }
  }, [query]);
  /* -------------------------------------------------------------------------- */
  /*                                     API Section                            */
  /* -------------------------------------------------------------------------- */

  const handleFetchData = async (search_text: string) => {
    if (search_text) {
      try {
        setIsLoading(true);
        let resp = await getLookupAPIs(
          getValue(props, `lookup_api`, ""),
          getValue(props, `lookup_id`, ""),
          search_text
        );

        if (resp) {
          setinfo(resp);
          setIsLoading(false);
        } else {
          setinfo([]);
          setIsLoading(false);
        }
      } catch (error) {
        setIsLoading(false);
      }
    } else {
      fetchDefaultData();
      onChange(null);
    }
  };
  const handleFetchDataUponClose = async (search_text: string) => {
    try {
      setIsLoading(true);
      let resp = await getLookupAPIs(
        getValue(props, `lookup_api`, ""),
        "",
        search_text
      );
      if (resp) {
        setinfo(resp);
        setIsLoading(false);
      } else {
        setinfo([]);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };
  // useEffect(() => {
  //   if (getValue(props, `lookup_id`, "")) {
  //     fetchDefaultData();
  //   }
  // }, [getValue(props, `lookup_id`, "")]);
  const fetchDefaultData = async () => {
    try {
      setIsLoading(true);
      let resp = await getLookupAPIs(
        getValue(props, `lookup_api`, ""),
        getValue(props, `lookup_id`, ""),
        ""
      );
      if (resp) {
        setinfo(resp);
        setIsLoading(false);
      } else {
        setinfo([]);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const handleClickOption = (option: any) => {
    onChange && onChange(option);
    setInputChange(false);
  };

  const handleClose = (e: any) => {
    e.stopPropagation();
    handleFetchDataUponClose("");
    setQuery("");
    onChange(null);
    inputRef.current.focus();
    setIsOpen(true);
  };

  /* -------------------------------------------------------------------------- */
  /*                               Onchange section                             */
  /* -------------------------------------------------------------------------- */
  const toggleBox = (e: any) => {
    if (!getValue(props, `disabled`, false)) setIsOpen(!isOpen);
  };
  const toggle = (e: any) => {
    setIsOpen(e && e.target === inputRef.current);
  };
  const handleClickOutside = (event: any) => {
    if (ref.current && !ref.current.contains(event.target)) {
      //   console.log("clicked outside");
      setIsOpen(false);
    } else {
      //   console.log("click inside");
    }
  };
  /* ---------------------------  API Logics ----------------------------- */
  const filter = (options: any) => {
    return getValue(options, `length`, 0) > 0
      ? options.filter(
          (option: any) =>
            getValue(option, `[${label}]`, "") &&
            option[label].toLowerCase().indexOf(query.toLowerCase()) > -1
        )
      : [];
  };
  const findSelectedPipeline = (id: any) => {
    let list =
      getValue(info, `length`, 0) > 0
        ? info.filter(
            (item) =>
              getValue(item, `[${selectKey ? selectKey : "id"}]`, "") == id
          )
        : [];
    return getValue(list, `length`, 0) > 0
      ? getValue(list, `[${0}].label`, "")
      : "";
  };
  const valueLabel = useMemo(
    () => findSelectedPipeline(value),
    [value, props.value, getValue(info, `length`, 0) > 0]
  );
  /* ---------------------------  Static Logics ----------------------------- */

  const filter1 = (options: any) => {
    return getValue(options, `length`, 0) > 0
      ? options.filter(
          (option: any) =>
            getValue(option, `[${label}]`, "") &&
            option[label].toLowerCase().indexOf(query.toLowerCase()) > -1
        )
      : [];
  };
  const findSelectedValue = (id: any) => {
    let list =
      getValue(data, `length`, 0) > 0
        ? data.filter(
            (item: object) =>
              getValue(item, `[${selectKey ? selectKey : "id"}]`, "") == id
          )
        : [];
    return getValue(list, `length`, 0) > 0
      ? getValue(list, `[${0}].label`, "")
      : "";
  };
  const valueLabel1 = useMemo(
    () => findSelectedValue(value),
    [value, data, getValue(data, `length`, 0) > 0]
  );

  return (
    <>
      {getValue(props, `lookup_api`, "") ? (
        <div className={"dropdownselect-form"} ref={ref}>
          {getValue(props, `showLabel`, false) && (
            <label
              // className={
              //   getValue(props, `mandatory`, false)
              //     ? "form-label-error"
              //     : "form-label"
              // }
              className={`${
                getValue(props, "mandatory", false)
                  ? "form-label-error"
                  : "form-label"
              } ${getValue(props, `showReportText`, false) ? "mb-0" : ""}`}
            >
              {getValue(props, `name`, "")}
              <span className="ms-1">
                {getValue(props, `mandatory`, false) ? "*" : ""}
              </span>
            </label>
          )}

          {getValue(props, `showReportText`, false) ? (
            <>
              <div
                className="small info-text"
                style={{
                  marginBottom: "8px",
                  opacity: "0.5",
                  fontSize: "12px",
                }}
              >
                [Add this expense to a report and submit it to claim
                reimbursement]
              </div>
            </>
          ) : (
            ""
          )}

          <div
            className={`selected-value-box position-relative ${
              isOpen ? "active" : ""
            } ${props.disabled ? "disabled" : ""} `}
            onClick={toggleBox} /* add custom width here */
            style={{
              width: getValue(props, `customStyle`, false)
                ? getValue(props, `headerWidth`, "")
                : width,
            }}
          >
            <div className="search_container">
              <img src={"/images/search1.svg"} className="search_image" />
              <input
                className="search_input"
                ref={inputRef}
                type="text"
                value={
                  inputChange
                    ? query
                      ? query
                      : valueLabel
                    : valueLabel
                    ? valueLabel
                    : query
                }
                name="searchTerm"
                autoComplete="off"
                placeholder={getValue(
                  props,
                  `placeholder`,
                  "Please Search here..."
                )}
                onChange={(e) => {
                  !getValue(e, `target.value`, "") && onChange(null);
                  setQuery(getValue(e, `target.value`, ""));
                  handleFetchData(getValue(e, `target.value`, ""));
                  setIsOpen(true);
                }}
                onClick={toggleBox}
                disabled={props.disabled}
              />
            </div>
            <div
              className="right_container"
              style={{ background: "transparent" }}
            >
              {valueLabel && !getValue(props, `disabled`, false) && (
                <div onClick={(e) => handleClose(e)}>
                  <CloseSmallSvgComponent />
                </div>
                // <div className="close_image_container">
                //   <img
                //     src={"/images/close.svg"}
                //     className="close_image"
                //     onClick={(e) => handleClose(e)}
                //   />
                // </div>
              )}
              <div className="arrow_image_container">
                <img
                  src={
                    isOpen
                      ? "/dropdown/arrow_up.svg"
                      : "/dropdown/arrow_down.svg"
                  }
                  className="arrow_image"
                />
              </div>
            </div>
          </div>

          <div
            className={`options ss-dd-selected-options-wrap ${
              isOpen ? "open" : ""
            }`} /* add custom width here */
            style={{
              width: getValue(props, `customStyle`, false)
                ? getValue(props, `optionsWidth`, "")
                : width,
              zIndex: 1000,
            }}
          >
            <div>
              <div className="option_container">
                {isLoading ? (
                  <div
                    style={{
                      textAlign: "center",
                      marginTop: "10px",
                      marginBottom: "5px",
                    }}
                  >
                    <img
                      src={`/dropdown/loader2.gif`}
                      className="loader"
                      style={{ height: "15px", width: "50px" }}
                    />
                  </div>
                ) : filter(info).length > 0 ? (
                  filter(info).map((option: object, index: number) => {
                    console.log(info, "---2---");
                    return (
                      <div
                        onClick={() => {
                          handleClickOption(option);
                          toggle(null);
                        }}
                        className={`option ${
                          getValue(
                            option,
                            `[${selectKey ? selectKey : "id"}]`,
                            ""
                          ) == value
                            ? "selected"
                            : ""
                        }`}
                        key={`${id}-${index}`}
                      >
                        <div className="selected_text">
                          {getValue(option, `[${label}]`, "")}
                        </div>
                        {getValue(
                          option,
                          `[${selectKey ? selectKey : "id"}]`,
                          ""
                        ) == value && (
                          <img
                            src="/dropdown/done.svg"
                            className="done_image"
                          />
                        )}
                      </div>
                    );
                  })
                ) : (
                  <div className="nodata">No Info Found</div>
                )}
              </div>
            </div>
            {getValue(props, `add`, "") ? (
              <div className="button_container">
                <img src={"/dropdown/add.svg"} className="button_image" />
                <p className="button_input">Add Button</p>
              </div>
            ) : null}
          </div>
        </div>
      ) : (
        <div className={"dropdownselect-form"} ref={ref}>
          {getValue(props, `showLabel`, false) && (
            <label
              className={`${
                getValue(props, "mandatory", false)
                  ? "form-label-error"
                  : "form-label"
              } ${getValue(props, `showReportText`, false) ? "mb-0" : ""}`}
            >
              {getValue(props, `name`, "")}
              <span className="ms-1">
                {getValue(props, `mandatory`, false) ? "*" : ""}
              </span>
            </label>
          )}
          {getValue(props, `showReportText`, false) ? (
            <>
              <div
                className="small info-text"
                style={{
                  marginBottom: "8px",
                  opacity: "0.5",
                  fontSize: "12px",
                }}
              >
                [Add this expense to a report and submit it to claim
                reimbursement]
              </div>
            </>
          ) : (
            ""
          )}
          <div
            className={`selected-value-box position-relative ${
              isOpen ? "active" : ""
            } ${props.disabled ? "disabled" : ""} `}
            onClick={toggleBox} /* add custom width here */
            style={{
              width: getValue(props, `customStyle`, false)
                ? getValue(props, `headerWidth`, "")
                : width,
            }}
          >
            <div className="search_container">
              <img src={"/images/search1.svg"} className="search_image" />
              <input
                className="search_input"
                ref={inputRef}
                type="text"
                value={
                  inputChange
                    ? query
                      ? query
                      : valueLabel1
                    : valueLabel1
                    ? valueLabel1
                    : query
                }
                name="searchTerm"
                autoComplete="off"
                placeholder={getValue(
                  props,
                  `placeholder`,
                  "Please Search here..."
                )}
                onChange={(e) => {
                  !e.target.value && onChange(null);
                  setQuery(e.target.value);
                }}
                onClick={toggleBox}
                style={{
                  minWidth: getValue(props, `customStyle`, false) && "50px",
                  background: props.disabled ? "#e9ecef" : "",
                }}
                disabled={props.disabled}
              />
            </div>
            <div
              className="right_container"
              style={{ background: "transparent" }}
            >
              {valueLabel1 && !getValue(props, `disabled`, false) && (
                // <div className="close_image_container">
                //   <img
                //     src={"/images/close.svg"}
                //     className="close_image"
                //     onClick={(e) => handleClose(e)}
                //   />
                // </div>
                <div onClick={(e) => handleClose(e)}>
                  <CloseSmallSvgComponent />
                </div>
              )}
              <div className="arrow_image_container">
                <img
                  src={
                    isOpen
                      ? "/dropdown/arrow_up.svg"
                      : "/dropdown/arrow_down.svg"
                  }
                  className="arrow_image"
                />
              </div>
            </div>
          </div>

          <div
            className={`options ss-dd-selected-options-wrap ${
              isOpen ? "open" : ""
            }`} /* add custom width here */
            style={{
              width: getValue(props, `customStyle`, false)
                ? getValue(props, `optionsWidth`, "")
                : width,
            }}
          >
            <div>
              <div className="option_container">
                {filter1(data).length > 0 ? (
                  filter1(data).map((option: object, index: number) => {
                    return (
                      <div
                        onClick={() => {
                          handleClickOption(option);
                          toggle(null);
                        }}
                        className={`option ${
                          getValue(
                            option,
                            `[${selectKey ? selectKey : "id"}]`,
                            ""
                          ) == value
                            ? "selected"
                            : ""
                        }`}
                        key={`${id}-${index}`}
                      >
                        <div className="selected_text ss-reports-dropdown-info">
                          <div className="ss-reports-dd-info-report-id">
                            {getValue(option, `report_id`, "")}
                          </div>
                          <div className="ss-reports-dd-info-report-label">
                            {getValue(option, `[${label}]`, "")}
                          </div>
                          <div className="ss-reports-dd-info-report-duration">
                            {convertDateWithSlash(
                              getValue(option, `duration_from`, "")
                            )}{" "}
                            -{" "}
                            {convertDateWithSlash(
                              getValue(option, `duration_to`, "")
                            )}
                          </div>
                          <div className="ss-reports-dd-info-report-amount">
                            {" "}
                            {getValue(option, `currency_symbol`, "")}{" "}
                            {getValue(option, `total`, "")}
                          </div>
                        </div>
                        {getValue(
                          option,
                          `[${selectKey ? selectKey : "id"}]`,
                          ""
                        ) == value && (
                          <img
                            src="/dropdown/done.svg"
                            className="done_image"
                          />
                        )}
                      </div>
                    );
                  })
                ) : (
                  <div className="nodata">No Data Found</div>
                )}
              </div>
            </div>
            {getValue(props, `add`, "") ? (
              <div
                className="button_container single-search-button-container"
                onClick={props.onClickAdd}
              >
                <img src={"/dropdown/add.svg"} className="button_image" />
                <p className="button_input">
                  {getValue(props, `showReportText`, false)
                    ? "Create new report"
                    : "Add Button"}{" "}
                </p>
              </div>
            ) : null}
          </div>
        </div>
      )}
      {props.validator && (
        <span className="form-error">
          {props.validator.current.message(
            getValue(props, `name`, ""),
            props.value,
            "required"
          )}
        </span>
      )}
    </>
  );
};

export default SingleSelectSearchDropdownReport;
